import { meetingFormData } from "../../utils/types"

export const initialData = {
  title: '',
  details: '',
  meetingDate: '',
  attachments: '',
}

export const checkValidation = (formData: meetingFormData) => {
  if (
    formData?.title == '' ||
    formData?.details == '' ||
    formData?.meetingDate == '' 
  ) {
    return true
  } else {
    return false
  }
}

export const calculatePageCount = (dataLength: number): number => {
  if (dataLength < 4) {
    return 1
  } else {
    return Math.ceil(dataLength / 4)
  }
}
